
// Define indexedDB variable
var indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB,
	dbVersion = 2.0;

// Create/open database
var request;
var db;
var createObjectStore = function (dataBase) {
	dataBase.createObjectStore("virdioSongsList");
}

window['dbaGlobal'] = null;

if (window.addEventListener)
	{
		window.addEventListener("message", putSongsInDb, false);
	}
else
	{
		window.attachEvent("message", putSongsInDb);
	}

function putSongsInDb(evnt) {

	if (!evnt.data || evnt.data.length !== 2 )
	{
		return;
	}

	console.log('sent song');

	var songs = evnt.data[0];
	var playlist_name = evnt.data[1];
	var i = 0;
    var promise = new Promise((resolve, reject) => {
		
		connectToDatabase().then((dba) => {
					Array.prototype.forEach.call(songs, (one_song) => {
						
						var customerObjectStore = dba.transaction(["virdioSongsList"], "readonly").objectStore("virdioSongsList");
						
						var countCustObjectStore = customerObjectStore.count();
						
						countCustObjectStore.onsuccess = function() {
							if( countCustObjectStore.result >= 150 ) { return window.parent.postMessage("songAddingLengthError", process.env.REACT_APP_ADMINURL); }
							
							var has_file = customerObjectStore.get(one_song.songId);
							has_file.onsuccess = function(event) {
								
								if ( typeof has_file.result === 'undefined' )
									{
										// Not found
										var customerObjectStore2 = dba.transaction(["virdioSongsList"], "readwrite").objectStore("virdioSongsList");
										var insert_req = customerObjectStore2.add(one_song);
										
										insert_req.onsuccess = function(event) 
											{
												if( i == (songs.length-1) ) { window.parent.postMessage("allSongsAdded", process.env.REACT_APP_ADMINURL);  }
												i++; 
											};
										insert_req.onerror = function(event) { window.parent.postMessage("songAddingError", process.env.REACT_APP_ADMINURL); console.log("Error adding"); console.log(event); };
									}
								else
									{
										if( i == (songs.length-1) ) { window.parent.postMessage("allSongsAdded", process.env.REACT_APP_ADMINURL); }
										console.log('Song already exist', one_song.songId);
										i++;
									}
							}
						  
						}
						
					});
			
			resolve("success");
		});
	});
	
	return promise;
};


var getSongFromDB = function(id)
{
	var promise = new Promise((resolve, reject) => {
		connectToDatabase().then((dba) => {
			var transaction = dba.transaction(["virdioSongsList"], 'readonly');
			var objectStore = transaction.objectStore("virdioSongsList");
			var ra = objectStore.get(id);
			ra.onsuccess = function(event) {
				
				console.log("found object");
				console.log(ra);
				
			  if( typeof ra.result !== 'undefined' )
				  {
					  console.log('buf type', typeof ra.result.blob);
					  if ( typeof ra.result.blob == 'string' )
					  {
						  console.log('fist enter');
						  fetch(ra.result.blob).then(res => res.arrayBuffer()).then(buffer => {
							   console.log('fist enter', buffer);
							  
							  var ret = new Blob([buffer], { type: 'video/mp3' });
							  
							  
							  console.log('blob url', URL.createObjectURL(ret));
							   resolve(URL.createObjectURL(ret));
							 });
					  }
					  else
						  {
							  var ret = new Blob([ra.result.blob], { type: 'video/mp3' });
							  
							  resolve(URL.createObjectURL(ret));
						  }
				  }
			  else
				{
					let userData = JSON.parse(localStorage.getItem("userData"));
					if ( userData.showCompleteBodyAlert == 0 ) { window.$('#no-playlist-found').modal('show'); }
					reject("unable to find song #1");
					localStorage.setItem('forceHidePlaylist', true); 
				}
			};
		});
	});
	
	return promise;
}

window['getSongById'] = getSongFromDB;

var connectToDatabase = function()
	{
		if ( window['dbaGlobal'] !== null )
			{
				console.log('Connecting to database... Reuse');
				var promise = new Promise(function(resolve, reject) { resolve(window['dbaGlobal']); });
			}
		else
			{
				console.log('Connecting to database...');
				request = indexedDB.open("VirdioSongCollection", dbVersion); 
				
				request.onerror = function (event) {
					console.log("Error creating/accessing IndexedDB databasewww", event);
				};

				var promise = new Promise(function(resolve, reject) {
					request.onsuccess = function (event) { 
						db = event.target.result;
						
						window['dbaGlobal'] = db;
						
						console.log('DB connect success');
						console.log(db);
						window['rdbb'] = db;
						
						if (db.setVersion) {
							if (db.version !== dbVersion) {
								var setVersion = db.setVersion(dbVersion);
								setVersion.onsuccess = function () {
									console.log('version change');
									createObjectStore(db);
									resolve(db);
								};
							}
						else 
							{
								resolve(db);
							}
						}
						else 
							{
								resolve(db);
							}
					}
						
					
				});
				
				
				
				
				request.onupgradeneeded = function(event) {
					
					console.log('upgrade needed');
					
				  try {
				  var db = event.target.result;
				  // Create an objectStore to hold information about our customers.
				  
				  var objectStore = db.createObjectStore("virdioSongsList", { keyPath: "songId" }); 
				  // Create an index to search customers by name. We may have duplicates
				  // so we can't use a unique index.
				  objectStore.createIndex("name", "name", { unique: false });
				  objectStore.createIndex("blob", "blob", { unique: false });
				  } catch (e) { }
				  
				};
			}
		
		
		
		return promise; 	
	}	
	
export { getSongFromDB } 